import { render, staticRenderFns } from "./outburstSetting.vue?vue&type=template&id=163d4ca0&scoped=true&"
import script from "./outburstSetting.vue?vue&type=script&lang=js&"
export * from "./outburstSetting.vue?vue&type=script&lang=js&"
import style0 from "./outburstSetting.vue?vue&type=style&index=0&id=163d4ca0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163d4ca0",
  null
  
)

export default component.exports